declare global {
  interface Window {
    smartlook?: (command: string, ...args: unknown[]) => void;
  }
}
interface SmartlookUserProps {
  id?: number | string | null;
  firstName?: string | null;
  lastName?: string | null;
  cognitoUsername?: string | null;
  email?: string | null;
}
export const PROJECT_SWITCHED = 'project_switched';

const simpleHash = (str: string): string => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
};

const isEnabled = (): boolean => {
  return Boolean(
    import.meta.env.VITE_APP_SMARTLOOK_ID && import.meta.env.VITE_APP_SMARTLOOK_ID !== ''
  );
};

function smartlookIdentify(userId: string, properties?: Record<string, unknown>) {
  if (!window.smartlook || !isEnabled()) return;
  window.smartlook('identify', userId, properties);
}

export function smartlookIdentifyUser(
  user: SmartlookUserProps,
  options?: { tenant?: string | null; project?: string | null }
) {
  if (!user.id) return;

  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.cognitoUsername;

  const contextKey = [options?.tenant, options?.project].filter(Boolean).join('_');
  const uniqueUserId = contextKey ? `${user.id}_${simpleHash(contextKey)}` : `${user.id}`;

  smartlookIdentify(uniqueUserId, {
    name,
    email: user.email,
    tenant: options?.tenant,
    project: options?.project,
  });
}

export function smartlookResetIdentity(
  user: SmartlookUserProps,
  options?: { tenant?: string | null; project?: string | null }
) {
  if (!window.smartlook || !isEnabled()) return;

  // Re-initialize Smartlook to start a completely new session
  window.smartlook('init', import.meta.env.VITE_APP_SMARTLOOK_ID);

  setTimeout(() => {
    smartlookIdentifyUser(user, options);
  }, 200);
}

export function smartlookTrack(eventName: string, properties?: object) {
  if (!window.smartlook || !isEnabled()) return;
  window.smartlook('track', eventName, properties);
}
